import React from "react";
import classes from "./styles/style.module.css";

const PreDesc = ({ name, desc }) => {
  return (
    <div className={classes.preDesContainer}>
      <h3>{name}</h3>
      <p dangerouslySetInnerHTML={{ __html: desc }}></p>
    </div>
  );
};

export default PreDesc;
